export default __webpack_public_path__ + "static/media/googleAnalytics.89f9725d.png";